import { RadioGroup, Radio, styled, Theme, Divider } from '@material-ui/core';

export const StyledRadioGroup = styled(RadioGroup)<Theme>(({ theme }) => ({
  justifyContent: 'space-between',
  alignItems: 'baseline',
  '& label:first-of-type': {
    marginLeft: 0,
  },
  '& label:last-of-type': {
    marginRight: 0,
  },
  '& .MuiFormControlLabel-root ': {
    width: '64px',
  },

  '&.margin-zero': {
    '& label ': {
      margin: 0,
    },
    '& .MuiFormControlLabel-root ': {
      width: 'unset',
    },
  },
  '& .MuiFormControlLabel-label': {
    textAlign: 'center',
  },
}));

export const StyledRadio = styled(Radio)<Theme>(({ theme }) => ({
  margin: 0,

  '& svg': {
    fontSize: '1.5rem',
  },
  '&.Mui-checked': {
    '& svg:first-of-type': {
      color: theme.palette.ternary.dark,
      zIndex: 100,
    },
    '& svg:last-of-type': {
      color: theme.palette.ternary.main,
      transform: 'scale(2)',
    },
  },
}));

export const StyledDivider = styled(Divider)<Theme>(({ theme }) => ({
  backgroundColor: '#000000',
  height: '2px',
  margin: '12px 0 0 0',
}));
